import classNames from 'classnames';
import missionComplete from '~/components/Icon/missionComplete.png';
import timeExpired from '~/components/Icon/timeExpired.png';
import styles from './MissionStamp.module.scss';
export type MissionStampProps = {
  className?: string;
  ended?: boolean;
};

export const MissionStamp = ({ className, ended = false }: MissionStampProps) =>
  ended ? (
    <img
      src={timeExpired}
      alt="time expired"
      className={classNames(styles.stamp, className)}
      width={100}
      height={100}
    />
  ) : (
    <img
      src={missionComplete}
      alt="mission complete"
      className={classNames(styles.stamp, className)}
      width={100}
      height={100}
    />
  );
